export default function ComparisonChecklist() {
  const checklistItems = [
    {
      category: 'Licensing & Insurance',
      items: [
        'Valid Texas contractor license',
        'General liability insurance',
        'Workers compensation coverage',
        'Manufacturer certifications'
      ]
    },
    {
      category: 'Experience & Expertise',
      items: [
        'Years in business in El Paso',
        'Portfolio of completed projects',
        'Specialty in window/door types',
        'Knowledge of local building codes'
      ]
    },
    {
      category: 'Product Quality',
      items: [
        'Energy Star certified products',
        'Warranty coverage details',
        'Brand reputation and options',
        'Custom design capabilities'
      ]
    },
    {
      category: 'Pricing & Value',
      items: [
        'Detailed written estimates',
        'Transparent pricing breakdown',
        'Financing options available',
        'Competitive market rates'
      ]
    },
    {
      category: 'Installation Process',
      items: [
        'Professional installation crew',
        'Timeline and scheduling',
        'Cleanup and disposal services',
        'Post-installation inspection'
      ]
    },
    {
      category: 'Customer Service',
      items: [
        'Responsive communication',
        'Online reviews and ratings',
        'References from past clients',
        'Warranty and support services'
      ]
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Contractor Comparison Checklist
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Use this comprehensive checklist to evaluate and compare window and door contractors before making your decision
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {checklistItems.map((section, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-md"
            >
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-500 text-white rounded-lg">
                  <i className="ri-checkbox-circle-line text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">
                  {section.category}
                </h3>
              </div>
              
              <ul className="space-y-3">
                {section.items.map((item, idx) => (
                  <li 
                    key={idx}
                    className="flex items-start gap-3 text-gray-700"
                  >
                    <i className="ri-check-line text-teal-500 text-lg mt-0.5 flex-shrink-0"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-teal-50 rounded-xl p-8 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Ready to Compare Contractors?
          </h3>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
            Get free quotes from multiple licensed window and door contractors in El Paso and compare their services, pricing, and expertise
          </p>
          <button className="px-8 py-4 bg-teal-500 text-white rounded-lg font-semibold hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer">
            Get Free Quotes
          </button>
        </div>
      </div>
    </section>
  );
}
